import React from "react";

// components


export default function Worker() {
  return (
    <>
   
      <div className="flex flex-wrap  mb-4">
       hi its workers
      </div>
     
  
    </>
  );
}
